import DocumentationButton from "components/DocumentationButton";
import { LogoAwsColored } from "components/icons/generated";
import Box from "ds/components/Box";
import EmptyState from "ds/components/EmptyState";
import { getDocsUrl } from "utils/getDocsUrl";

const AwsIntegrationFormDrawerEmptyState = () => {
  return (
    <Box>
      <EmptyState
        title="AWS integration"
        caption="The managed AWS integration is not enabled in your Spacelift installation, but you can still use OIDC Federation. Learn how to do it by clicking on the button below."
        icon={LogoAwsColored}
        padding="x-large"
      >
        <DocumentationButton
          analyticsTitle="AWS documentation button clicked"
          to={getDocsUrl("/integrations/cloud-providers/oidc/aws-oidc")}
          label="Documentation"
        />
      </EmptyState>
    </Box>
  );
};

export default AwsIntegrationFormDrawerEmptyState;
